import { createSlice } from '@reduxjs/toolkit'

const   initialState ={
    token:'',
    name:'',
    email:'',
    jobtitle: '',
    phone: '',
    security:1000,
    userstatus:'',
    user_group:'',
    dialler_username: '',
    flg_username: '',
    flg_userid: '',
    user_id: null,
    id: null,
    permission_edit: false
}

export const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
          addauth: (state,action) => {
            return {...state, ...action.payload}
          },
          updateauth: (state,action) => {
            return {...state, ...action.payload}
          },

  }
});
export const { addauth, updateauth} = authSlice.actions
export default  authSlice.reducer;